import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { scrollTop } from '../../../Helpers/Helpers'
import _ from 'lodash'


const Links = props => {

    const [links, setLinks] = useState([
        {
            id: 1,
            title: 'Informacje',
            expanded: false,
            list: [{
                external: true,
                url: '/o-nas#ref0',
                name: 'Kim jesteśmy?'
            },
            {
                external: true,
                url: '/o-nas#ref1',
                name: 'Nasza kadra'
            }, {
                external: true,
                url: '/dla-rodzicow#ref2',
                name: 'Dokumenty'
            }, {
                external: false,
                url: '/kontakt',
                name: 'Kontakt'
            }, {
                external: false,
                url: '/blog',
                name: 'Blog'
            }]
        },
        {
            id: 2,
            title: 'Dla rodziców',
            expanded: false,
            list: [{
                external: false,
                url: '/dla-rodzicow',
                name: 'Opieka zdrowotna'
            },
            {
                external: true,
                url: '/dla-rodzicow#ref0',
                name: 'Bezpieczeństwo'
            }, {
                external: true,
                url: '/dla-rodzicow#ref6',
                name: 'Faktury'
            }, {
                external: true,
                url: '/dla-rodzicow#ref5',
                name: 'Dojazd'
            }]
        },
        {
            id: 3,
            title: 'Rezerwacja',
            expanded: false,
            list: [{
                external: true,
                url: '/dla-rodzicow#ref1',
                name: 'Rezerwacja - krok po kroku'
            },
            {
                external: true,
                url: '/dla-rodzicow#ref3',
                name: 'Kuratorium oświaty'
            }, {
                external: false,
                url: '/kontakt',
                name: 'Wyślij pytanie'
            }, {
                external: true,
                url: '/dla-rodzicow#ref4',
                name: 'Płatności'
            }, {
                external: false,
                url: '/rabaty',
                name: 'Rabaty'
            }]
        },
        {
            id: 4,
            title: 'Inne',
            expanded: false,
            list: [{
                external: false,
                url: '/faq',
                name: 'Często zadawane pytania'
            },
            {
                external: true,
                url: '/o-nas#ref4',
                name: 'Nasze ośrodki'
            }, {
                external: false,
                url: '/kontakt',
                name: 'Lokalizacja'
            }, {
                external: false,
                url: '/media/galeria',
                name: 'Galeria'
            }, {
                external: false,
                url: '/opinie',
                name: 'Opinie'
            }]
        },
        {
            id: 5,
            title: 'O nas',
            expanded: false,
            list: [{
                external: false,
                url: '/nasza-kadra',
                name: 'Nasza kadra'
            },
            {
                external: false,
                url: '/dlaczego-z-nami',
                name: 'Dlaczego z nami'
            }, {
                external: false,
                url: '/nasz-sprzet',
                name: 'Nasz sprzęt'
            }, {
                external: true,
                url: '/o-nas#ref4',
                name: 'Nasze ośrodki'
            }]
        }
    ])

    const openList = (id) => {
        const newList = _.cloneDeep(links)
        newList.map(l => {
            l.expanded = l.id === id ? !l.expanded : false
        })
        setLinks(newList)
    }

    return (
        <footer>
            <div className="footer-links">
                <div className="container">
                    <div className="row">
                        {links.map(link => (
                            <div key={link.id} className="col-12 col-md-4 col-lg-2">
                                <p onClick={() => openList(link.id)} className="footer-links-header" role="button" aria-expanded={link.expanded} aria-label={`${link.expanded ? 'Zwiń' : 'Rozwiń'} sekcję ${link.title}`}>{link.title} <span className={`icon-down-open ${link.expanded ? 'icon-down-opn--opened' : ''}`}></span></p>
                                <ul className={`footer-links__list ${link.expanded ? 'footer-links__list--opened' : ''}`}>
                                    {link.list.map((l, i) => (
                                        <li key={i}>
                                            {l.external ? (
                                                <a href={l.url}>{l.name}</a>
                                            ) : (
                                                <Link onClick={scrollTop} to={l.url}>{l.name}</Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container">
                    <span>
                        Copyright &copy; {new Date().getFullYear()} ViaCamp. Wszelkie prawa zastrzeżone.<br />

                        <span className="footer-cookies">
                            Zapoznaj się z <Link onClick={scrollTop} to="/polityka-ciasteczek"><span className="text-primary has-cursor-pointer">polityką cookies</span></Link>
                            &nbsp;oraz&nbsp; <Link onClick={scrollTop} to="/polityka-prywatnosci"><span className="text-primary has-cursor-pointer">polityką prywatności</span></Link>.
                        </span>
                    </span>
                    <p className="footer-cookies-info">
                        ViaCamp sp. z o.o. z siedzibą w Przywidzu, ul. Spacerowa 3, 83-047 Przywidz, zarejestrowana w Sądzie Rejonowym Gdańsk - Północ w Gdańsku, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod nr KRS: 0000943479, NIP: 588-247-59-88, REGON: 520822685. Wysokość kapitału zakładowego 5 000 zł.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Links
